module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Page of omnichannel messages from wepipe","entity":"Messages","soon":"Soon"},"pt-BR":{"title":"Página de conversas omnichannel da wepipe","entity":"Conversas","soon":"Em breve"}}')
  delete Component.options._Ctor
}
